var storeName = '__cn_lowcode_utils__';

if (!window[storeName]) {
  window[storeName] = {
    extComponemts: [],
    internelItemMap: {}
  };
} else {
  if (!window[storeName].extComponemts) {
    window[storeName].extComponemts = [];
  }

  if (!window[storeName].internelItemMap) {
    window[storeName].internelItemMap = {};
  }
}

var privateStore = window[storeName];
var ExtComponents = privateStore.extComponemts;
export function registerExtComponent(name, component) {
  for (var i = 0; i < ExtComponents.length; i++) {
    if (ExtComponents[i].name === name) {
      throw new Error("some name: " + name);
    }
  }

  var cmpt = {
    name: name,
    module: component
  };
  ExtComponents.push(cmpt);
  return cmpt;
}
export function getExtComponent(name) {
  for (var i = 0; i < ExtComponents.length; i++) {
    if (ExtComponents[i].name === name) {
      return ExtComponents[i];
    }
  }

  return null;
}
export function getExtComponents() {
  return ExtComponents;
}
var InternelItemMap = privateStore.internelItemMap;
export function setItem(key, val) {
  InternelItemMap[key] = val;
}
export function getItem(key) {
  return InternelItemMap[key];
}